import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { ConsentManagement } from '../components/ui/ConsentManagement';
import { useConsentCheck } from '../hooks/useConsentCheck';
import { IStore } from '../interfaces/StoreTypes';
import { buildLanguageRoute } from '../utils/languageRouteBuilder';
import url from '../helpers/url';
import { ROUTE_CONSTANT } from '@libs/constants';
type ConsentManagementScreenProps = {
    screenName: string;
    screenKey: string;
};

export const ConsentManagementScreen: React.FC<ConsentManagementScreenProps> = ({ screenName, screenKey }) => {
    const profile = useSelector((store: IStore) => store.profile);
    const { data: consentData, isLoading } = useConsentCheck(profile?.selectedProfile);

    if (isLoading) {
        return <></>;
    }

    if (!consentData.consentNeeded) {
        return (
            <Navigate
                to={url.route(consentData.exitkid ? ROUTE_CONSTANT.EXIT_KID : ROUTE_CONSTANT.CONSENT_MANAGEMENT)}
                replace
            />
        );
    }

    return (
        <>
            <ConsentManagement />
        </>
    );
};
